export function withTableauDashboards (tableauUrl): void {
  const scriptUrl = tableauUrl + `/user/tableau/javascripts/api/tableau.embedding.3.latest.min.js`;

  if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
    const node = document.createElement("script");
    node.src = scriptUrl;
    node.type = "module";
    node.async = true;

    document.body.appendChild(node);
  }
}
